module.exports = __webpack_public_path__ + "media/bootstrap-icons/wallet2-eb72e337.svg";